(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectlog', {
            parent: 'entity',
            url: '/projectlog',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectlog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectlog/projectlogs.html',
                    controller: 'ProjectlogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectlog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectlog-detail', {
            parent: 'projectlog',
            url: '/projectlog/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectlog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectlog/projectlog-detail.html',
                    controller: 'ProjectlogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectlog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectlog', function($stateParams, Projectlog) {
                    return Projectlog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectlog',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectlog-detail.edit', {
            parent: 'projectlog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-dialog.html',
                    controller: 'ProjectlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectlog', function(Projectlog) {
                            return Projectlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectlog.new', {
            parent: 'projectlog',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-dialog.html',
                    controller: 'ProjectlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                actiontaken: null,
                                actiontakenby: null,
                                actiontakendate: null,
                                actiontype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectlog', null, { reload: 'projectlog' });
                }, function() {
                    $state.go('projectlog');
                });
            }]
        })
        .state('projectlog.edit', {
            parent: 'projectlog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-dialog.html',
                    controller: 'ProjectlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectlog', function(Projectlog) {
                            return Projectlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectlog', null, { reload: 'projectlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectlog.delete', {
            parent: 'projectlog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-delete-dialog.html',
                    controller: 'ProjectlogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectlog', function(Projectlog) {
                            return Projectlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectlog', null, { reload: 'projectlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
